import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import firebase from 'firebase';
import Vuetify from 'vuetify';

Vue.config.productionTip = false;

firebase.initializeApp({
    apiKey: 'AIzaSyAnzzn_KmM1e1tnUSplov47z8HtSJ7_b2E',
    authDomain: 'iglportal-189312.firebaseapp.com',
    databaseURL: 'https://iglportal-189312.firebaseio.com',
    projectId: 'iglportal-189312',
    storageBucket: 'iglportal-189312.appspot.com',
    messagingSenderId: '717038647261',
    appId: '1:717038647261:web:3680802dd85a6be5442834',
});

let app: Vue;

firebase.auth().onAuthStateChanged(() => {
    if (!app) {
        Vue.use(Vuetify);
        const vuetify = new Vuetify({
            icons: {
                iconfont: 'md',  // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4'
            },
            theme: {
                dark: false,
            },
            themes: {
                light: {
                    primary: '#4682b4',
                    secondary: '#b0bec5',
                    accent: '#8c9eff',
                    error: '#b71c1c',
                },
            },
        });
        app = new Vue({
            router,
            store,
            render: (h) => h(App),
            vuetify,
        }).$mount('#app');
    }
});
